module.exports = __webpack_public_path__ + "img/w3_cart_black.e30f5d85.png";